import http from '../request';

export const contactUslist = (params: IcontactUsParams): RES<IcontactUsModel> => http.post("/system/us/list1", params)

export const contactUsget = (): RES<IcontactUsModel> => http.get("/system/us/get")

export const contactUsadd= (params: IcontactUsParams): RES<IcontactUsModel> => http.post("/system/us/add1", params ,{
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
})
